var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column","height":"89vh"}},[_vm._v("\n\t第一个页面\n")])}
var staticRenderFns = []

export { render, staticRenderFns }